import type { Smartplug2 } from "../smartplug2/sp2";

export function subscriptionIsActive(device: Device): boolean {
	if (device.Subscription.PriceIds.Current) {
		return true;
	}

	if (device.Subscription.Trialing) {
		return true;
	}

	return false;
}

export type Device =
	| FarmcamSim
	| Fencealarm
	| Fencealarm2
	| Smartplug
	| Smartplug2;

export type DeviceIdType = "IMEI" | "IMSI";

export type DeviceType =
	| "FarmCam SIM"
	| "FenceAlarm"
	| "FenceAlarm2"
	| "SmartPlug"
	| "SmartPlug2";
